var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0982 4.93671C16.7236 4.10127 15.7309 2.58228 15.4255 0.987342C15.3491 0.683544 15.3491 0.379747 15.3491 0H11.2255V9.64557V16.3291C11.2255 18.2278 9.69818 19.8228 7.71273 19.8228C7.10182 19.8228 6.56727 19.6709 6.03273 19.443C4.96364 18.9114 4.12364 17.6962 4.12364 16.4051C4.12364 14.5063 5.65091 12.9114 7.63636 12.9114C8.01818 12.9114 8.32364 12.9873 8.70545 13.0633V9.87342V8.96203C8.32364 8.88608 8.01818 8.88608 7.63636 8.88608C3.43636 8.88608 0 12.2278 0 16.481C0 18.9873 1.29818 21.2658 3.28364 22.6329C4.50545 23.4684 6.03273 24 7.63636 24C11.8364 24 15.2727 20.6582 15.2727 16.481V7.82278C16.8 9.18987 18.9382 9.87342 21 9.72152V6.68354V5.62025C20.0073 5.8481 18.9382 5.5443 18.0982 4.93671Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.df2395ea27633b8f14d1a59310da24c7.svg";
export { ForwardRef as ReactComponent };